import { component as defineComponent } from 'flightjs';
import localTimeFromTimeZone from 'app/lib/moment/localtime';

var entryDesignerTimezone = function () {
    this.after('initialize', function () {
        const timezone = this.$node.data('designer-timezone');
        this.displayLocalTime(timezone);
    });

    this.displayLocalTime = function (timezone) {
        var designersTimeInfo = this.$node.data('designers-time');
        const localTime = timezone ? localTimeFromTimeZone(timezone) : '';

        if (localTime) {
            designersTimeInfo = designersTimeInfo.replace('%time%', localTime);
            this.$node.text(designersTimeInfo);
        }
    };
};

export default defineComponent(entryDesignerTimezone);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/entry-designer-timezone.js